import {ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output} from "@angular/core";
import {SessionModel} from "../../orchestration/session.model";
import {Subscription} from "rxjs";
import {AnalyticsService} from "../../orchestration/analytics.service";
import {IdentityModel} from "../../identity/identity.model";
import {ButtonLayout, ButtonProminence} from "../../buttons/button/button";
import {IdentificationMode} from "../../identity/identification-page/identification-mode";
import {NavigationService} from "../../orchestration/navigation.service";
import {GroupOrderModel} from "../../group-order/group-order.model";
import {OrderingContextModel} from "../../ordering-context/ordering-context.model";
import {IdentityEvents} from "../../identity/identity-events";
import {GroupOrderEvents} from "../../group-order/group-order-events";
import {DealModel} from "../../deal/deal.model";
import {ButtonShape, ButtonStyle} from "../../orchestration/app-entity.model";

@Component({
    selector: "woa-feature-button-panel",
    templateUrl: "./feature-button-panel.component.html"
})
export class FeatureButtonPanelComponent implements OnInit, OnDestroy {
    @Output() onOpenGroupOrder: EventEmitter<void> = new EventEmitter<void>();

    ButtonProminence = ButtonProminence;
    ButtonStyle = ButtonStyle;
    ButtonLayout = ButtonLayout;
    ButtonShape = ButtonShape;

    hasGroupOrder: boolean = false;
    groupOrderHighlighted: boolean = false;

    private subscriptions: Subscription = new Subscription();

    constructor(public sessionModel: SessionModel,
                public orderingContextModel: OrderingContextModel,
                public identityModel: IdentityModel,
                private groupOrderModel: GroupOrderModel,
                private dealModel: DealModel,
                private navigationService: NavigationService,
                private changeDetectorRef: ChangeDetectorRef,
                private analyticsService: AnalyticsService) {
        this.hasGroupOrder = this.groupOrderModel.hasGroupOrder;
    }

    ngOnInit() {
        this.subscriptions.add(IdentityEvents.currentMember$.subscribe(() => this.changeDetectorRef.detectChanges()));
        this.subscriptions.add(IdentityEvents.loginComplete$.subscribe(() => this.changeDetectorRef.detectChanges()));
        this.subscriptions.add(GroupOrderEvents.groupOrderStatus$.subscribe(() => {
            if (!this.hasGroupOrder && this.groupOrderModel.hasGroupOrder) {
                this.groupOrderHighlighted = true;
                this.changeDetectorRef.markForCheck();
                setTimeout(() => {
                    this.groupOrderHighlighted = false;
                    this.changeDetectorRef.markForCheck();
                }, 3200);
            } else {
                this.changeDetectorRef.detectChanges();
            }
            this.hasGroupOrder = this.groupOrderModel.hasGroupOrder;
        }));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    get showMemberButton(): boolean {
        return this.identityModel.allowMemberLogin && (this.sessionModel.currentApp.promoteMemberLogin || this.sessionModel.currentApp.integratedLoyalty) && !this.showLoyaltyCard;
    }

    get showLoyaltyCard(): boolean {
        return !this.identityModel.isGuestUser && this.identityModel.hasActiveLoyaltyCard;
    }

    get showGroupOrderButton(): boolean {
        return this.orderingContextModel.currentStore && this.orderingContextModel.orderType && this.groupOrderModel.canHaveGroupOrder;
    }

    get dealCodesAvailable(): boolean {
        return this.identityModel.currentMember && this.identityModel.currentMember.anySelectByDealCodeInApp;
    }

    get showDealButton(): boolean {
        return (this.dealModel.appliedDeals.length || this.dealCodesAvailable) && !this.sessionModel.waiterMode;
    }

    get showActions(): boolean {
        return this.showMemberButton || this.showLoyaltyCard || this.showGroupOrderButton || this.showDealButton;
    }

    async member(): Promise<void> {
        if (this.identityModel.isGuestUser) {
            // noinspection ES6MissingAwait
            this.analyticsService.trackFeatureButton("member login");
            return this.navigationService.createPage("woa-identification-page", {"mode": IdentificationMode.LOGIN});
        } else {
            // noinspection ES6MissingAwait
            this.analyticsService.trackNavOption("profile");
            return this.navigationService.createPage("woa-profile-edit-page");
        }
    }

    async loyaltyCards(): Promise<void> {
        // noinspection ES6MissingAwait
        this.analyticsService.trackNavOption("loyalty-cards");
        return this.navigationService.createPage("woa-loyalty-cards-page");
    }

    async groupOrder(): Promise<void> {
        // noinspection ES6MissingAwait
        this.analyticsService.trackFeatureButton("group order");
        this.onOpenGroupOrder.emit();
    }

    async deal(): Promise<void> {
        // noinspection ES6MissingAwait
        this.analyticsService.trackFeatureButton("deal code");
        return this.navigationService.createPage("woa-deal-code-entry-page");
    }
}



// WEBPACK FOOTER //
// ./src/app/ordering-page/feature-button-panel/feature-button-panel.component.ts